/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { Box, makeStyles } from '@material-ui/core';

import Logo from 'public/logo-no-text.svg';

const PageLoader = (): JSX.Element => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Box className={classes.imageContainer}>
        <img src={Logo} />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100vw',
    height: '100vh',
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  imageContainer: {
    width: 200,
    height: 200
  }
}));

export default PageLoader;
